import React, { useEffect, useState } from "react";
import MainHeader from "../../../../layouts/pageLayout/MainHeader";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import PayoutSplit from "./PayoutSplit";
import AffiliatePayout from "./AffiliatePayout";
import Tabination from "../../../../reusableComponents/Tabination";
import WithdrawalHistory from "./WithdrawalHistory";

const PayoutIndex = () => {
  const location = useLocation();

  const path = location.pathname.split("/")[2];
  const [activeTab, setActiveTab] = useState(0);
  const items = [
    {
      name: "Trading Account",
      path: "payout-split",
    },
    {
      name: "Affiliate",
      path: "affiliate-payout",
    },
    {
      name: "Withdrawal History",
      path: "withdrawal-history",
    },
  ];
  useEffect(() => {
    switch (path) {
      case "payout-split":
        setActiveTab(0);
        break;
      case "affiliate-payout":
        setActiveTab(1);
        break;
      case "withdrawal-history":
        setActiveTab(2);
        break;
      default:
        break;
    }
  }, [path]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="withdrawalPageContainer">
      <div className="pageNavigator">
        <Tabination
          variant={7}
          tabItems={items}
          activeTab={activeTab}
        />
      </div>
      <Routes>
        <Route
          path="/"
          element={
            <Navigate
              to="payout-split"
              replace={true}
            />
          }
        />
        <Route
          path="payout-split"
          element={<PayoutSplit />}
        />
        <Route
          path="affiliate-payout"
          element={<AffiliatePayout />}
        />
        <Route
          path="withdrawal-history"
          element={<WithdrawalHistory />}
        />
        <Route
          path="*"
          element={
            <Navigate
              to="/"
              replace={true}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default PayoutIndex;
